import { useI18n } from "@/context/LanguageContext";

export const LanguageSwitcher = ({ className = "" }) => {
  const { lang, setLang, langs } = useI18n();
  return (
    <div
      data-testid="language-switcher"
      className={`inline-flex items-center border-2 border-[#141518] bg-white text-[#141518] ${className}`}
    >
      {langs.map((l, i) => (
        <button
          key={l.code}
          type="button"
          data-testid={`lang-${l.code}`}
          onClick={() => setLang(l.code)}
          aria-pressed={lang === l.code}
          className={`px-2.5 py-1.5 text-[11px] font-condensed font-bold uppercase tracking-[0.18em] transition-colors ${
            lang === l.code
              ? "bg-[#141518] text-white"
              : "hover:bg-[#7AD5DC] text-[#141518]"
          } ${i > 0 ? "border-l-2 border-[#141518]" : ""}`}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
};
